export enum PermissionEnum {
  MAPS_VIEW_LIST = 'maps:view.list',
  MAPS_ADD_NEW = 'maps:add.new',
  MAPS_DELETE = 'maps:delete',
  MAPS_EDIT = 'maps:edit',
  MAPS_COPY_LINK = 'maps:copy.link',
  MAPS_DUPLICATE = 'maps:duplicate',
  MAPS_OPEN = 'maps:open',
  MAPS_SAVE = 'maps:save',

  FOLDERS_ADD_NEW = 'folders:add.new',
  FOLDERS_EDIT = 'folders:edit',
  FOLDERS_DELETE = 'folders:delete',
  FOLDERS_MOVE_MAPS = 'folders:move.maps',

  LAYERS_VIEW_LIST = 'layers:view.list',
  LAYERS_ADD_NEW = 'layers:add.new',
  LAYERS_DELETE = 'layers:delete',
  LAYERS_EDIT = 'layers:edit',
  LAYERS_VIEW = 'layers:view',

  COMPANIES_VIEW_LIST = 'companies:view.list',
  COMPANIES_ADD_NEW = 'companies:add.new',
  COMPANIES_DELETE = 'companies:delete',
  COMPANIES_EDIT = 'companies:edit',

  ROLES_VIEW_LIST = 'roles:view.list',
  ROLES_ADD_NEW = 'roles:add.new',
  ROLES_EDIT = 'roles:edit',
  ROLES_DELETE = 'roles:delete',
  ROLES_MANAGE_PERMISSIONS = 'roles:manage.permissions',

  USERS_VIEW_LIST = 'users:view.list',
  USERS_ASSIGN_ROLE = 'users:assign.role',

  AUDIT_LOGS_VIEW_LIST = 'audit.logs:view.list',
}
